export const creditCardReissueExternal = {
    targetClientId: '',
};
